import React, { useRef, useState, useEffect, useContext } from "react";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";
import NotificationAlert from "react-notification-alert";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Collapse,
  Toast,
  ToastHeader,
  ToastBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from "reactstrap";
import "./style.css";
import FormOportunidade from "./formulario/Form";
import api from "../../../../../services/api";
import EmpresaContext from "../../../../../contexts/Empresa";
import axios from "axios";
import { AxiosResponse } from "axios";

// Adicione estes imports
import { useHistory } from "react-router-dom";

export default function Automac() {
  const notificationAlert = useRef<any>();
  const [isOpenOportunidades, setIsOpenOportunidades] = useState(false);
  const [isOpenAnuncios, setIsOpenAnuncios] = useState(false);
  const [displayForm, setDisplayForm] = useState("none");
  const [displayMain, setDisplayMain] = useState("flex");
  // const [displayForm, setDisplayForm] = useState("flex");
  // const [displayMain, setDisplayMain] = useState("none");
  const [automacoesInfo, setAutomacoesInfo] = useState([]);
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [eventoID, setEventoID] = useState<number>(0);
  const [nomeEntidade, setNomeEntidade] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [acoesBtn, setAcoesBtn] = useState([]);

  const history = useHistory();
  const [colaboradoresStats, setColaboradoresStats] = useState({
    total: 0,
    comWhatsapp: 0,
    loading: true,
  });

  // Toogle IA

  const [isAssistantActive, setIsAssistantActive] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleChange = () => {
    if (!isAssistantActive) {
      setShowConfirmation(true);
    } else {
      // Se já estiver ativo, desativa direto
      toggleAssistantStatus();
    }
  };

  const toggleAssistantStatus = async () => {
    setIsLoading(true);

    const handleSuccess = () => {
      setIsAssistantActive(!isAssistantActive);
      notify(
        "success",
        `Assistente ${
          !isAssistantActive ? "ativado" : "desativado"
        } com sucesso!`,
      );
    };

    const handleError = () => {
      notify(
        "danger",
        `Erro ao ${!isAssistantActive ? "ativar" : "desativar"} o assistente`,
      );
    };

    try {
      const { data: colaboradores } = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/colaboradores`,
      );

      const numerosWhatsapp = colaboradores
        .flatMap((colab: any) =>
          colab.canaisContato
            ?.filter((c: any) => c.canal_id === 25 && c.identificador)
            .map((c: any) => c.identificador.replace(/\D/g, "")),
        )
        .filter(Boolean);
      const REACT_APP_API_IA = process.env.REACT_APP_API_IA;
      if (!REACT_APP_API_IA) {
        console.error("API_IA não está definida.");
        setIsLoading(false);
        notify("danger", "Erro ao ativar IA: API_IA não definida.");
        return;
      }

      if (!isAssistantActive) {
        //Ativar IA primeiro
        try {
          await axios.post(`${REACT_APP_API_IA}/api/auth/authorize`, {
            empresaId: empresaSelecionada?.id,
            phoneNumbers: numerosWhatsapp,
          });
        } catch (error) {
          console.error("Erro ao ativar IA:", error);
          setIsLoading(false);
          notify("danger", "Erro ao ativar IA.");
          return;
        }
        // Ativar - Criar parâmetro
        api
          .post(
            `/common/parametros-empresas`,
            {
              chave: "status_ia",
              valor: true,
              descricao: "Status do Assistente de IA",
            },
            {
              headers: {
                empresa_id: empresaSelecionada?.id,
              },
            },
          )
          .then(handleSuccess)
          .catch(handleError)
          .finally(() => {
            setIsLoading(false);
            setShowConfirmation(false);
          });
      } else {
        // Desativar IA primeiro
        const REACT_APP_API_IA = process.env.REACT_APP_API_IA;

        try {
          await axios.put(`${REACT_APP_API_IA}/api/auth/inactivate`, {
            phoneNumbers: numerosWhatsapp,
          });
        } catch (error) {
          console.error("Erro ao desativar IA:", error);
          setIsLoading(false);
          notify("danger", "Erro ao desativar IA.");
          return;
        }
        // Desativar - Remover parâmetro
        api
          .delete(`/common/parametros-empresas/status_ia`, {
            headers: {
              empresa_id: empresaSelecionada?.id,
            },
          })
          .then(handleSuccess)
          .catch(handleError)
          .finally(() => {
            setIsLoading(false);
            setShowConfirmation(false);
          });
      }
    } catch (error) {
      console.error("Erro ao verificar status da IA:", error);
      setIsLoading(false);
      notify("danger", "Erro ao verificar status da IA.");
    }
  };
  // Toogle IA

  const notify = (type: any, msg: string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text" style={{ zIndex: 100 }}>
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 3,
    };
    if (notificationAlert.current)
      notificationAlert.current.notificationAlert(options);
  };
  interface eventoType {
    descricao: String;
    entidadeid: number;
    eventoid: number;
    nomeentidade: String;
    nomeevento: String;
    quant_automacoes_empresa: number;
    total_automacoes: number;
  }

  interface entidadeType {
    id: number;
    nome: String;
  }

  // interface automacoesModel {
  //     nomeEvento: String;
  //     descricao: String;
  //     eventoID: number;
  // }

  // trocar essa função ou estudar uma lógica para fazer modificar essa função e não ficar dados fixos
  const toggle = (e: string) => {
    switch (e) {
      case "oportunidades":
        setIsOpenOportunidades(!isOpenOportunidades);
        break;
      case "anúncios":
        setIsOpenAnuncios(!isOpenAnuncios);
        break;
      // case "clientes":
      //     setIsOpenClientes(!isOpenClientes);
      //     break;
    }
  };

  async function loadColaboradoresStats() {
    try {
      const { data } = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/colaboradores`,
      );

      const comWhatsapp = data.filter(
        (colab: any) =>
          colab.canaisContato?.some((c: any) => c.canal_id === 25) &&
          colab.roles?.some((role: any) => role.name === "Comercial") &&
          colab.userEmpresas?.some((ue: any) => ue.situacao === "A"),
      ).length;

      const total = data.filter(
        (colab: any) =>
          colab.roles?.some((role: any) => role.name === "Comercial") &&
          colab.userEmpresas?.some((ue: any) => ue.situacao === "A"),
      ).length;

      setColaboradoresStats({
        total,
        comWhatsapp,
        loading: false,
      });
    } catch (error) {
      notify("danger", "Erro ao carregar dados dos colaboradores");
      setColaboradoresStats((prev) => ({ ...prev, loading: false }));
    }
  }

  async function reqAutomacoes() {
    await api
      .get(`automacoes/${empresaSelecionada?.id}`)
      .then((response) => {
        setEventos(response.data.eventos);
        setNomeEntidade(response.data.nomeEntidade);
      })
      .catch(() => {
        notify("danger", "Erro, tente novamente ou contate o ADM.");
      });
  }

  async function reqEventoAutomacao(
    eventoID: number,
  ): Promise<AxiosResponse<any>> {
    return await api.get(
      `automacoes/${empresaSelecionada?.id}/eventoautomacao/${eventoID}`,
    );
  }

  async function reqAcoes(eventoID: number): Promise<AxiosResponse<any>> {
    return await api.get(
      `/automacoes/${empresaSelecionada?.id}/acoes/${eventoID}`,
    );
  }

  function loadForm(eventoID: Number) {
    reqEventoAutomacao(Number(eventoID))
      .then((response) => {
        setDisplayForm("flex");
        setDisplayMain("none");
        setAutomacoesInfo(response.data);
        setEventoID(Number(eventoID));
      })
      .catch(() => {
        setDisplayForm("none");
        setDisplayMain("flex");
        notify("danger", "Erro ao carregar as automações e seus estados.");
      });

    reqAcoes(Number(eventoID))
      .then((respose) => {
        setAcoesBtn(respose.data);
      })
      .catch(() => {
        setDisplayForm("none");
        setDisplayMain("flex");
        notify("danger", "Erro ao carregar as automações não utilizadas.");
      });
  }

  useEffect(() => {
    reqAutomacoes();
    if (empresaSelecionada?.id) {
      setColaboradoresStats((prev) => ({ ...prev, loading: true }));
      loadColaboradoresStats();
    }
  }, [empresaSelecionada]);

  useEffect(() => {
    const checkInitialStatus = async () => {
      if (!empresaSelecionada?.id) return;

      try {
        const response = await api.get(
          `/common/parametros-empresas/status_ia/pe-show`,
          {
            headers: {
              empresa_id: empresaSelecionada.id,
            },
          },
        );

        setIsAssistantActive(response.data?.status_ia === "true");
      } catch (error) {
        console.error("Erro ao verificar status da IA:", error);
        setIsAssistantActive(false);
      }
    };

    checkInitialStatus();
  }, [empresaSelecionada]);

  return (
    <>
      {/* {alert} */}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Automações" parentName="Minha empresa" />
      <div className="w-100">
        <Row>
          <Col>
            <FormOportunidade
              displayForm={displayForm}
              setDisplayForm={setDisplayForm}
              setDisplayMain={setDisplayMain}
              automacoesInfo={automacoesInfo}
              eventoID={eventoID}
              loadForm={() => {
                loadForm(eventoID);
              }}
              reqAutomacoes={() => {
                reqAutomacoes();
              }}
              acoesBtnInfo={acoesBtn}
            />
            <Card style={{ display: displayMain }}>
              <CardHeader style={{ position: "sticky", top: 0, zIndex: 1 }}>
                <h1>Automações</h1>
              </CardHeader>

              {/* Nova seção especial */}
              <Card className="mb-4 automacoes-container assistente-ia">
                <CardBody className="p-4 position-relative">
                  <div className="automacoes-fundo"></div>
                  <div className="automacoes-estrelas"></div>
                  <img
                    src="/boneco-ia.png"
                    className="assistente-icon"
                    alt="Assistente IA"
                  />
                  <div className="conteudo-card-estelar d-flex justify-content-between align-items-center">
                    <div style={{ flex: 1 }}>
                      <h5>Ative o Assistente de Vendas no WhatsApp com IA!</h5>
                      <p>Conecte sua equipe ao futuro das vendas...</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        // marginTop: "1.5rem",
                        width: "50%",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "1.8rem",
                            fontWeight: 700,
                            color: "#fff",
                          }}
                        >
                          {colaboradoresStats.loading
                            ? "--"
                            : colaboradoresStats.total}
                          <p
                            style={{
                              fontSize: "0.9rem",
                              opacity: 0.8,
                              margin: 0,
                            }}
                          >
                            Colaboradores
                          </p>
                        </div>

                        <div
                          style={{
                            fontSize: "1.8rem",
                            fontWeight: 700,
                            color: "#fff",
                          }}
                        >
                          {colaboradoresStats.loading
                            ? "--"
                            : colaboradoresStats.comWhatsapp}
                          <p
                            style={{
                              fontSize: "0.9rem",
                              opacity: 0.8,
                              margin: 0,
                            }}
                          >
                            Com WhatsApp
                          </p>
                        </div>
                      </div>

                      <Button
                        color="link"
                        style={{
                          padding: "6px",
                          // marginTop: "1rem",
                          color: "#fff",
                        }}
                        onClick={() => history.push("/admin/equipes")}
                      >
                        Adicionar números de WhatsApp
                      </Button>
                    </div>
                    <div className="d-flex align-items-center">
                      <CustomInput
                        type="switch"
                        id="assistantToggle"
                        checked={isAssistantActive}
                        onChange={handleToggleChange}
                        disabled={isLoading}
                        className="custom-toggle-assistant"
                      />
                      {isAssistantActive}
                    </div>
                  </div>
                </CardBody>
              </Card>

              {/* Seções dinâmicas */}
              {nomeEntidade.map((entidade: entidadeType) => {
                return (
                  <CardBody outline body>
                    {/* Conteúdo original das seções */}
                    <div className="checklist-item checklist-item-info">
                      <Button
                        color="white"
                        onClick={() => {
                          toggle(`${entidade.nome.toLowerCase()}`);
                        }}
                        style={{ fontWeight: 600 }}
                      >
                        {entidade.nome}
                      </Button>
                    </div>

                    <Collapse
                      className="collapse-menu"
                      isOpen={
                        entidade.nome === "Oportunidades"
                          ? isOpenOportunidades
                          : isOpenAnuncios
                      }
                    >
                      <div
                        className="p-3 my-2 rounded"
                        style={{ display: "flex" }}
                      >
                        {eventos.map((values: eventoType) => {
                          if (entidade.nome === values.nomeentidade) {
                            return (
                              <Toast
                                className="evento-toast"
                                onClick={() => {
                                  loadForm(values.eventoid);
                                }}
                              >
                                <ToastHeader
                                  style={{ backgroundColor: "#F7F7F7" }}
                                >
                                  {values.nomeevento}
                                </ToastHeader>
                                <ToastBody className="evento-toast-body">
                                  <div className="text-automacao">
                                    <p>{values.descricao}</p>
                                  </div>
                                  <p className="num-automacao">
                                    {values.quant_automacoes_empresa} de{" "}
                                    {values.total_automacoes} automações
                                  </p>
                                </ToastBody>
                              </Toast>
                            );
                          }
                        })}
                      </div>
                    </Collapse>
                    <Modal
                      isOpen={showConfirmation}
                      toggle={() => setShowConfirmation(false)}
                    >
                      <ModalHeader toggle={() => setShowConfirmation(false)}>
                        Confirmar ativação
                      </ModalHeader>
                      <ModalBody>
                        Tem certeza que deseja ativar o Assistente de Vendas com
                        IA? Esta ação iniciará a configuração automática do
                        serviço.
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          color="secondary"
                          onClick={() => setShowConfirmation(false)}
                        >
                          Cancelar
                        </Button>
                        <Button
                          color="primary"
                          onClick={toggleAssistantStatus}
                          disabled={isLoading}
                        >
                          {isLoading ? "Processando..." : "Confirmar"}
                        </Button>
                      </ModalFooter>
                    </Modal>
                  </CardBody>
                );
              })}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
